<template>
  <div class="sequence-wrapper">
    <div class="sequence-container">
      <div class="sequence-title">
        <span>经历排序</span>
      </div>
      <Draggable
        class="sequence-list"
        :list="list"
        :options="{ animation: 200, ghostClass: 'ghost' }"
        @change="draggableChange"
      >
        <div
          class="sequence-item"
          v-for="(item, index) in list"
          :key="index"
        >
          <i class="iconfont icontiaoxu"></i>
          <span class="name text-overflow">{{ item[displayKey] }}</span>
        </div>
      </Draggable>
    </div>
  </div>
</template>
<script>
import Draggable from 'vuedraggable';

export default {
  name: 'ExperienceSequence',
  components: {
    Draggable,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    displayKey: {
      type: String,
      default: 'name',
    },
  },
  methods: {
    draggableChange(event) {
      this.$emit('draggableChange', event);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/sequence.scss';
</style>